module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ds0At"))).then(() => parcelRequire('dJXJK'));